"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IngestContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IngestContext = _react["default"].createContext({
  fireEvent: function fireEvent() {
    return new Promise(function (resolve) {
      return resolve();
    });
  }
});

exports.IngestContext = IngestContext;